export const STORE_KEY = 'auth';
export const USERS_STORE_KEY = 'users';
export const SESSION_SETTINGS_SAVED = 'settingsSaved';
export const REFRESH_TOKEN = 'refresh_token';
export const BEARER_TOKEN = 'bearer_token';
export const COOKIE_BEARER_KEY = 'BEARER';
export const COOKIE_BEARER_EXP_KEY = 'BEARER_EXP';
export const COOKIE_MERCURE_KEY = 'mercureAuthorization';
export const REQUEST_TOKEN_EXPIRED = 'Request token expired';
